import { Action } from '@ngrx/store';
import { AlertInfo, AlertInfoState, PlaceholderEnum } from '@nx-fe/alert';

export enum AlertActionTypes {
  NewAlert = '[Alert] New alert',
  RemoveAlert = '[Alert] Remove alert',
  ClearPlaceholder = '[Alert] Clear placeholder',
  AddPlaceholder = '[Alert] Add placeholder',
  RemovePlaceholder = '[Alert] Remove placeholder',
}

export class NewAlertAction implements Action {
  readonly type = AlertActionTypes.NewAlert;

  constructor(public alert: AlertInfo) {}
}

export class RemoveAlertAction implements Action {
  readonly type = AlertActionTypes.RemoveAlert;

  constructor(public id?: number) {}
}

export class ClearPlaceholderAction implements Action {
  readonly type = AlertActionTypes.ClearPlaceholder;

  constructor(public placeholder: PlaceholderEnum) {}
}

export class AddPlaceholderAction implements Action {
  readonly type = AlertActionTypes.AddPlaceholder;

  constructor(public placeholder: PlaceholderEnum) {}
}

export class RemovePlaceholderAction implements Action {
  readonly type = AlertActionTypes.RemovePlaceholder;

  constructor(public placeholder: PlaceholderEnum) {}
}

export type AlertActions =
  | NewAlertAction
  | RemoveAlertAction
  | ClearPlaceholderAction
  | AddPlaceholderAction
  | RemovePlaceholderAction;
